/* eslint-disable @typescript-eslint/no-explicit-any */
// HTTP helpers shared with the React front of appcraft-forms (src/utils/fetch.js and the uploaders).

export type FetchImpl = typeof fetch;

export function globalFetch(): FetchImpl {
  return (...args: Parameters<FetchImpl>) => fetch(...args);
}

export async function sendJson(method: string, url: string, json: unknown, fetchImpl: FetchImpl = globalFetch()): Promise<any> {
  const res = await fetchImpl(url, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  });
  return res.json();
}

export async function getJson(url: string, fetchImpl: FetchImpl = globalFetch()): Promise<any> {
  const res = await fetchImpl(url, {
    headers: {
      Accept: 'application/json',
    },
  });
  return res.json();
}

/** Multipart upload of one file (`file` part) to the files service. */
export async function uploadFile(url: string, file: Blob, fetchImpl: FetchImpl = globalFetch()): Promise<any> {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetchImpl(url, {
    method: 'POST',
    body: formData,
  });
  return res.json();
}

export function withQuery(url: string, query: Record<string, string | undefined>): string {
  const params = Object.keys(query)
    .filter((key) => query[key] !== undefined && query[key] !== '')
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key] as string)}`)
    .join('&');
  if (!params) return url;
  return url.indexOf('?') === -1 ? `${url}?${params}` : `${url}&${params}`;
}
